import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {

  },
  mutations: {
    SET_FILES_POSITION(state, data) {
      state.data.positions.forEach(element => {
        if (element.id == data.id) {
          element.photo = data.files;
        }
      })
    },
    SET_POSITIONS_FROM_ORDER(state, positions) {
      if (!state.data) {
        state.data = {positions: []};
      }
      state.data.positions = positions;
    },
    SET_STORAGE_DELIVERY_FROM_ORDER(state, storage_delivery) {
      if (!state.data) {
        state.data = {storage_delivery: []};
      }
      state.data.storage_delivery = storage_delivery;
    },
    SET_STARAGE_SHIPMENT_FROM_ORDER(state, storage_shipment) {
      if (!state.data) {
        state.data = {storage_shipment: []};
      }
      state.data.storage_shipment = storage_shipment;
    },
    SET_POSITIONS_PAGINATION_FROM_ORDER(state, pagination) {
      if (!state.data) {
        state.data = {};
      }
      state.data.positions_pagination = pagination;
    },
    SET_FILTER_OPTIONS_FROM_ORDER(state, filterOptions) {
      if (!state.data) {
        state.data = {};
      }
      state.data.filter_options = filterOptions || {};
    },
    ADD_POSITION(state, index) {
      const element = state.data.positions[index];
      const copy = { ...element, id: 'n' + Math.random(),
        photo: [],
        date_planned_arrival: '',
        date_ready_shipment: '',
        date_arrival_supplier: '',
        date_supplier_order: '',
        date_order_shipment: '',
        quantity_shipped: 0,
        storage_shipment: '',
        comment: '',
        status: 'В работе',
        color: ''
      };
      state.data.positions.splice(index + 1, 0, copy);

    }
  },
  actions: {
    async fetchPositions({ commit, state }, params = {}) {

      const requestId = (state.lastRequestId || 0) + 1;
      state.lastRequestId = requestId;

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/order/position/', {
          params: {
            page: params.page,
            page_size: params.pageSize,
            sort: params.sort,
            sort_dir: params.sortDir,
            ...(params.filters || {}),
          }
        });
        if (state.lastRequestId !== requestId) {
          return;
        }
        commit('SET_DATA', {data:response.data.data});
        commit('SET_ERROR', null);
      } catch (error) {
        if (state.lastRequestId !== requestId) {
          return;
        }
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
      } finally {
        if (state.lastRequestId === requestId) {
          commit('SET_LOADING', false);
        }
      }
    },
    setFile({ commit, state }, data) {
        commit('SET_FILES_POSITION', data);
    },
    setFilePositions({ commit }, data) {
      commit('SET_FILES_POSITION', data);
    },
    addPosition({ commit, state }, index) {
      commit('ADD_POSITION', index);
    },
    syncPositionsFromOrder({ commit }, data) {
      commit('SET_POSITIONS_FROM_ORDER', data.positions);
      commit('SET_STORAGE_DELIVERY_FROM_ORDER', data.storage_delivery);
      commit('SET_STARAGE_SHIPMENT_FROM_ORDER', data.storage_shipment);
      commit('SET_POSITIONS_PAGINATION_FROM_ORDER', data.positions_pagination);
      commit('SET_FILTER_OPTIONS_FROM_ORDER', data.filter_options);
    }
  },
  getters: {
    positions: state => state.data?.positions?state.data.positions:[],
    positionsPagination: state => state.data?.positions_pagination || null,
    positionsSort: state => state.data?.positions_sort || null,
    filterOptions: state => state.data?.filter_options || {},
    storage_delivery: state => state.data?.storage_delivery?state.data.storage_delivery:[],
    storage_shipment: state => state.data?.storage_shipment?state.data.storage_shipment:[],
    positionsLoading: state => state.loading,
    positionsError: state => state.error,
    positionsLoaded: state => state.loaded,
  }
})
